import axios from 'axios';
import { useQuery } from 'react-query';

const useGetLayoutDiagrams = () => {
  const { data, isLoading, isRefetching } = useQuery(
    'layoutDiagrams',
    async () => {
      const layouts = (await axios.get('/standardization/layouts')).data;
      return layouts;
    },
    { refetchOnMount: true }
  );

  return {
    layouts: data,
    isLoading: isLoading || isRefetching,
  };
};

export default useGetLayoutDiagrams;
